// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"20a65d5e","142":"7472a168","974":"5b3340c1"}[chunkId] + ".chunk.css";
};